<template>
  <div
    @mouseenter="show = true"
    @mouseleave="show = false"
    class="text-right fixed top-0 right-0 mt-3 mr-3"
  >
    <button
      @click="show = !show"
      class="text-white transform hover:scale-110 focus:scale-110"
      :title="$t('regWizPopUp.serverInfoToggle')"
      type="button"
    >
      <UnraidSvgUtilInfo class="fill-current w-4 h-4" />
    </button>

    <transition name="fade" mode="out-in">
      <div v-show="show" class="text-white text-left p-2 bg-black dark:text-black dark:bg-white rounded shadow-lg">
        <div class="text-sm flex flex-row">
          <div class="font-semibold text-right mr-2 pr-2 border-r-2 border-orange-dark">
            <h4>{{ $t('regWizPopUp.serverInfo.name') }}</h4>
            <h4 v-if="serverdesc">{{ 'Description' }}</h4>
            <h4>{{ $t('regWizPopUp.serverInfo.ip') }}</h4>
            <h4 v-if="flashvendor">{{ $t('regWizPopUp.serverInfo.flash') }}</h4>
            <h4 v-if="flashproduct">{{ $t('regWizPopUp.serverInfo.product') }}</h4>
            <h4
              v-if="showRegGuid"
              :title="isRegGuidBlacklisted ? 'GUID Blacklisted' : ''"
              :class="{
                'text-red': isRegGuidBlacklisted,
              }"
            >{{ isRegGuidBlacklisted ? 'Registered GUID Blacklisted' : 'Registered GUID' }}</h4>
            <h4
              v-if="guid"
              :title="isGuidBlacklisted ? 'GUID Blacklisted' : ''"
              :class="{
                'text-red': isGuidBlacklisted,
              }"
            >{{ isGuidBlacklisted ? 'Blacklisted GUID' : $t('regWizPopUp.serverInfo.GUID') }}</h4>
          </div>
          <div class="text-left">
            <p class="select-all">{{ servername }}</p>
            <p v-if="serverdesc" class="select-all">{{ serverdesc }}</p>
            <p class="select-all">{{ internalip }}</p>
            <p v-if="flashvendor" class="select-all">{{ flashvendor }}</p>
            <p v-if="flashproduct" class="select-all">{{ flashproduct }}</p>
            <p
              v-if="showRegGuid"
              class="select-all"
              :title="isRegGuidBlacklisted ? 'GUID Blacklisted' : ''"
              :class="{
                'text-red': isRegGuidBlacklisted,
              }"
            >{{ regGuid }}</p>
            <p
              v-if="guid"
              class="select-all"
              :title="isGuidBlacklisted ? 'GUID Blacklisted' : ''"
              :class="{
                'text-red': isGuidBlacklisted,
              }"
            >{{ guid }}</p>
          </div>
        </div>
        <div v-if="NODE_ENV === 'development'" class="flex flex-col">
          <hr class="w-full h-2px my-2 bg-gradient-to-r from-red to-orange shadow-none border-none rounded-none" />
          <h4 class="text-sm uppercase italic">Dev Helpers ⚙️</h4>
          <router-link :to="{ name: 'Troubleshoot' }" class="text-sm underline">{{ $t('regWizPopUp.routes.troubleshoot.heading.default') }}</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UnraidSvgUtilInfo from '@unraid/shared-components/assets/svg/util/info.svg';

import { NODE_ENV } from '../../env';

export default {
  name: 'UiServerInfo',
  components: {
    UnraidSvgUtilInfo,
  },
  data: () => ({
    show: false,
    NODE_ENV,
  }),
  computed: {
    ...mapState([
      'flashproduct',
      'flashvendor',
      'guid',
      'guidValid',
      'guidForValidation',
      'guidBlacklisted',
      'regGuid',
      'servername',
      'serverdesc',
      'internalip',
    ]),
    showRegGuid() { return this.regGuid && this.regGuid !== this.guid; },
    isRegGuidBlacklisted() { return this.regGuid && this.regGuid === this.guidForValidation && this.guidBlacklisted && this.guidValid === false; },
    isGuidBlacklisted() { return this.guid && this.guid === this.guidForValidation && this.guidBlacklisted && this.guidValid === false; },
  },
};
</script>
